// src/utils/globalState.js
import { ref } from 'vue'

class GlobalState {
  constructor() {
    this.user = ref(null)
    this.isInitialized = ref(false)
    this.initPromise = null
  }

  // 设置用户信息
  setUser(userData) {
    this.user.value = userData
  }

  // 获取用户信息
  getUser() {
    return this.user.value
  }

  // 等待初始化完成
  async waitForInitialization() {
    if (this.isInitialized.value) {
      return this.user.value
    }

    if (!this.initPromise) {
      this.initPromise = new Promise(resolve => {
        const check = () => {
          if (this.isInitialized.value) {
            resolve(this.user.value)
          } else {
            setTimeout(check, 100)
          }
        }
        check()
      })
    }

    return this.initPromise
  }

  // 标记为已初始化
  setInitialized() {
    this.isInitialized.value = true
  }

  // 清理状态
  clear() {
    this.user.value = null
    this.isInitialized.value = false
    this.initPromise = null
  }
}

export const globalState = new GlobalState()